export default __webpack_public_path__ + "static/media/persotypesNantes-2.299bba8a.pdf";